import * as React from 'react';

const context = {
  withoutMediaConditions: false,
};

export const UtilityContext = React.createContext(context);
